import { render, staticRenderFns } from "./domain-search.html?vue&type=template&id=0c45366e&scoped=true&"
import script from "./domain-search.js?vue&type=script&lang=js&"
export * from "./domain-search.js?vue&type=script&lang=js&"
import style0 from "./domain-search.scss?vue&type=style&index=0&id=0c45366e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45366e",
  null
  
)

export default component.exports